<template>
  <UApp :toaster="{ position: 'top-center' }">
    <CsrfToken>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </CsrfToken>
  </UApp>
</template>
